import createTransition from 'shared-tokens/utils/createTransition';
import colors from 'shared-tokens/utils/tokens/colors';

export const mainCls = 'radio-field';
export const clsInput = `${mainCls}__input`;
export const clsCtr = `${mainCls}__ctr`;
export const clsCtrIndet = `${mainCls}__ctr-inder`;

const boxSize = '18px';
const colorBorder = colors.f3.rgba;
const colorTransp = 'rgba(255, 255, 255, 0)';

export default {
  [clsInput]: {
    position: 'absolute',
    width: 0,
    height: 0,
    padding: 0,
    border: 0,
    opacity: 0,

    [`&:checked + .${clsCtr}`]: {
      borderColor: colorTransp,

      '&::after': {
        opacity: '1',
      }
    },

    [`&:disabled + .${clsCtr}`]: {
      opacity: '0.5',
    },
  },

  [mainCls]: {
    userSelect: 'none',
    display: 'inline-block',
  },

  [clsCtr]: {
    width: boxSize,
    height: boxSize,
    border: `1px solid ${colorBorder}`,
    transition: createTransition(['background-color', 'border-color']),
    position: 'relative',

    '&::after': {
      top: 0,
      left: 0,
      bottom: 0,
      right: 0,
      margin: 'auto',
      width: '6px',
      height: '6px',
      content: '""',
      opacity: 0,
      position: 'absolute',
      backgroundColor: 'white',
      borderRadius: '100%',
    },
  },
};